<template>
  <div
    class="relative flex-shrink-0 w-[16.46vw] h-auto p-[1.04vw] gap-[1.04vw] flex flex-col justify-center items-start border border-[#EEEEEE]"
  >
    <!-- 新闻资讯 -->
    <div class="w-full h-auto flex flex-col justify-center items-start">
      <!-- tag -->
      <div
        class="relative bg-[#F0F0F0] w-full h-[1.77vw] mb-[0.52vw] rounded flex flex-row justify-start items-center"
      >
        <div
          class="relative bg-[#05358C] w-auto h-full px-[1.04vw] py-[0.31vw] rounded flex justify-start items-center"
        >
          <p
            class="text-[0.83vw] text-[#FFFFFF] text-center font-harmony font-normal"
          >
            新闻资讯
          </p>
        </div>
      </div>
      <!-- 动态筛选 -->
      <div
        class="relative w-full h-auto flex flex-col justify-start items-start"
      >
        <div
          class="relative w-full text-[0.83vw] text-[#323232] text-start font-harmony font-normal"
        >
          <div
            @click="handleCategoryClick('')"
            :class="[
              'cursor-pointer',
              'hover:text-[#05358C]',
              {
                'text-[#05358C]': !isSubPage && !$route.query.category,
              },
            ]"
          >
            全部新闻
          </div>
          <div
            class="border-dashed border-[#b3b3b3] border-b h-[0.05vw] my-[0.63vw]"
          ></div>

          <div
            @click="handleCategoryClick('company')"
            :class="[linkClass('company'), 'cursor-pointer']"
          >
            公司新闻
          </div>
          <div
            class="border-dashed border-[#b3b3b3] border-b h-[0.05vw] my-[0.63vw]"
          ></div>

          <div
            @click="handleCategoryClick('join')"
            :class="[linkClass('join'), 'cursor-pointer']"
          >
            加盟动态
          </div>
          <div
            class="border-dashed border-[#b3b3b3] border-b h-[0.05vw] my-[0.63vw]"
          ></div>

          <div
            @click="handleCategoryClick('industry')"
            :class="[linkClass('industry'), 'cursor-pointer']"
          >
            行业资讯
          </div>
        </div>
      </div>
    </div>

    <!-- 联系我们 -->
    <div class="w-full h-auto flex flex-col justify-center items-start">
      <div
        class="relative bg-[#F0F0F0] w-full h-[1.77vw] mb-[0.52vw] rounded flex flex-row justify-start items-center"
      >
        <div
          class="relative bg-[#05358C] w-auto h-full px-[1.04vw] py-[0.31vw] rounded flex justify-start items-center"
        >
          <p
            class="text-[0.83vw] text-[#FFFFFF] text-center font-harmony font-normal"
          >
            联系我们
          </p>
        </div>
      </div>
      <div
        class="text-[0.73vw] text-[#323232] text-start font-harmony font-normal"
      >
        <p>总部地址：</p>
        <p>西安市沣东新城沣东大道2196号沣东自贸新天地文创街区2C</p>
        <p>联系电话：400 0336 691</p>
      </div>
    </div>

    <!-- 热门文章 -->
    <div class="w-full h-auto flex flex-col justify-center items-start">
      <div
        class="relative bg-[#F0F0F0] w-full h-[1.77vw] mb-[0.52vw] rounded flex flex-row justify-start items-center"
      >
        <div
          class="relative bg-[#05358C] w-auto h-full px-[1.04vw] py-[0.31vw] rounded flex justify-start items-center"
        >
          <p
            class="text-[0.83vw] text-[#FFFFFF] text-center font-harmony font-normal"
          >
            热门文章
          </p>
        </div>
      </div>
      <div
        class="relative w-full h-auto flex flex-col justify-start items-between"
      >
        <div
          v-for="(item, index) in rightShowNews"
          :key="item.id"
          :href="item.id"
          class="flex justify-start items-center gap-[0.26vw] hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
          @click="navigateToDetail(item.id)"
        >
          <div
            class="w-[0.26vw] h-[0.26vw] ml-[0.52vw] my-[0.52vw] bg-[#1C9AF3] rounded-full"
          ></div>
          <div
            class="justify-start text-[#323232] text-[0.73vw] font-normal font-harmony"
          >
            {{ truncateHot(item.newsTitle) }}
          </div>
          <div
            class="text-right text-[#9ca2af] text-[0.73vw] font-normal font-harmony ml-auto uppercase"
          >
            {{ item.publishedAt | formatZhDate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";


// 分类标识映射关系
const categoryMap = {
  company: "company_公司新闻",
  join: "join_加盟动态",
  industry: "industry_行业资讯",
};

export default {
  name: "NewsSidebar",
  props: ['selectedCategory','rightShowNews'],
  data() {
    return {
      hotList: [],
    };
  },
  created() {
    this.fetchHotNews();
  },
  computed: {
    // 直接从路由参数获取当前分类（不再依赖props）
    currentCategory() {
      const key = this.$route.query.category || "";
      return categoryMap[key] || "";
    },
    isSubPage() {
      return this.$route.path.startsWith("/News/info");
    },
  },
  methods: {
    // 处理滚动或跳转逻辑
    scrollOrPush(path, query = {}) {
      const isSamePath = this.$route.path === path;
      const isSameQuery =
        JSON.stringify(this.$route.query) === JSON.stringify(query);

      if (isSamePath && isSameQuery) {
        // 同路径 + 相同 query：手动回顶
        window.scrollTo({ top: 0 });
      } else {
        this.$router.push({ path, query });
      }
    },
    // 新闻分类跳转
    handleCategoryClick(categoryKey) {
        // console.log(categoryKey);
        // console.log(this.$route.query)
        if(categoryKey === this.$route.query.category){
            this.$router.push(this.$route.path)
            return;
        }
      const targetQuery = categoryKey ? { category: categoryKey } : {};
      window.localStorage.setItem("isClickNews","true")
      this.scrollOrPush("/News", targetQuery);
    },
    // 新闻详情跳转
    navigateToDetail(documentId) {
      this.scrollOrPush(`/News/info/${documentId}`);
    },

    linkClass(categoryKey) {
      const targetCategory = categoryMap[categoryKey] || "";
      return {
        "hover:text-[#05358C] transition-colors duration-200": true,
        "text-[#05358C]":
          !this.isSubPage && this.currentCategory === categoryMap[categoryKey],
      };
    },
    truncateHot(hot) {
      const maxLength = 9;
      return hot.length > maxLength ? hot.slice(0, maxLength) + "..." : hot;
    },
    async fetchHotNews() {
      try {
        // const baseUrl = "/api";
        // const response = await axios.get(
        //   `${baseUrl}/newsinfos?&sort=publishedAt:desc`
        // );
        // const { data } = response.data;
        // this.hotList = data
        //   .filter((item) => item.news_status?.trim() === "publish_发布")
        //   .slice(0, 5)
        //   .map((item) => ({
        //     documentId: item.documentId,
        //     title: item.news_title,
        //     date: item.news_publish_date,
        //     link: `/News/info/${item.documentId}`,
        //   }));

      } catch (error) {
        console.error("获取热门文章失败", error);
        this.hotList = [];
      }
    }

  },
};
</script>
